/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import ShortIcon from "../../../assets/icons/traffic/toggleable/IconLicenceDurationUnderTwo";
import MediumIcon from "../../../assets/icons/traffic/toggleable/IconLicenceDurationTwoToTen";
import LongIcon from "../../../assets/icons/traffic/toggleable/IconLicenceDurationMoreThanTen";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "../../../services/translations/translations";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { FormDataTypes } from "../../../types/FormDataTypes";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

export default function DriversLicensePeriod({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="driversLicensePeriod"
                question={translate("traffic.driversLicensePeriod.label", values)}
                options={[
                  {
                    labelText: translate("traffic.driversLicensePeriod.options.<2.label", values),
                    labelIcon: <ShortIcon />,
                    labelIconActive: <ShortIcon active />,
                    value: "<2",
                  },
                  {
                    labelText: translate("traffic.driversLicensePeriod.options.2-10.label", values),
                    labelIcon: <MediumIcon />,
                    labelIconActive: <MediumIcon active />,
                    value: "2-10",
                  },
                  {
                    labelText: translate("traffic.driversLicensePeriod.options.>10.label", values),
                    labelIcon: <LongIcon />,
                    labelIconActive: <LongIcon active />,
                    value: ">10",
                  },
                  {
                    labelText: translate("traffic.driversLicensePeriod.options.none.label", values),
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "none",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
